import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const PendingIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 12 12"
    sx={{ width: '12px', height: '12px', color: '#A7A7A7', ...sx }}
    {...props}
  >
    <path
      d="M7.5 5.5H6.5V3.5C6.5 3.36739 6.44732 3.24022 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24022 5.5 3.36739 5.5 3.5V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5H7.5C7.63261 6.5 7.75979 6.44732 7.85356 6.35355C7.94732 6.25979 8 6.13261 8 6C8 5.86739 7.94732 5.74022 7.85356 5.64645C7.75979 5.55268 7.63261 5.5 7.5 5.5ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53554C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47996 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1V1ZM6 10C5.20888 10 4.43552 9.76541 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53074C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44372 2.61217 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20888 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10V10Z"
      fill="inherit"
    />
  </SvgIcon>
)

PendingIcon.defaultProps = {
  sx: null,
}
